import { render, staticRenderFns } from "./ProfileActionChat.vue?vue&type=template&id=cd21c5f8&"
import script from "./ProfileActionChat.vue?vue&type=script&lang=js&"
export * from "./ProfileActionChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports